module.exports = __webpack_public_path__ + "static/media/logo1.94fc4930.png";